export enum SelectVersion {
  DEFAULT = 'default',
  SINGLE_SELECT = 'single-select',
  MULTI_SELECT = 'multi-select',
  COLOR_SELECT = 'color-select',
  FONT_SELECT = 'font-select',
}

export interface SelectOption {
  value: string | number;
  text: string;
  'sub-text'?: string;
  hsp?: boolean;
  visual?: string;
  font?: string;
  selected?: boolean;
}

export interface OptGroup {
  value?: string | number | null;
  label?: string | null;
}
